// extracted by mini-css-extract-plugin
module.exports = {"lia-dropdown":"NavbarDropdown_lia-dropdown__UxoG7"};